import bUTransferAPI from '@/apis/bu/bUTransferAPI.js';
import bUPlanWithDrawAPI from '@/apis/bu/buPlanWithDrawAPI.js';
import cAReceiptAPI from '@/apis/ca/cAReceiptAPI';
import baWithDrawAPI from '@/apis/ba/baWithdrawAPI.js';

const state = {
  dataEnterPaymentContent: [],
};
const getters = {};
const actions = {
  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT (chuyển khoản)
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataForEnterPaymentContentBUTransfer(context, payload) {
    let res = await bUTransferAPI.getDataForEnterPaymentContent(payload);
    if (res) {
      context.commit('setDataEnterPaymentContent', res);
    }
    return res;
  },
  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT (rút dự toán)
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataForEnterPaymentContentPlanWithdraw(context, payload) {
    let res = await bUPlanWithDrawAPI.getDataForEnterPaymentContent(payload);
    if (res) {
      context.commit('setDataEnterPaymentContent', res);
    }
    return res;
  },
  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT (phiếu thu)
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataForEnterPaymentContentCashReceipt(context, payload) {
    let res = await cAReceiptAPI.getDataForEnterPaymentContent(payload);
    if (res) {
      context.commit('setDataEnterPaymentContent', res);
    }
    return res;
  },
  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT (phiếu thu)
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataForEnterPaymentContentBAwithDraw(context, payload) {
    let res = await baWithDrawAPI.getDataForEnterPaymentContent(payload);
    if (res) {
      context.commit('setDataEnterPaymentContent', res);
    }
    return res;
  },
};
const mutations = {
  /**
   * set giá trị dữ liệu bảng nhập nội dung thanh toán trong form tham số in chứng từ 05TT
   * TTLONG 19.08.2022
   * @param {*} state
   */
  setDataEnterPaymentContent(state, payload) {
    state.dataEnterPaymentContent = payload.sortObject('sort_order').sortObject('SortOrder');
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
